import { useGetIdsHealthcareservicesHcsIdPreferences } from '@toktokdoctech/tokapi-client'
import useCurrentHcs from './useCurrentHcs'

const useAutomaticIdentityValidation = (): {
    isAutomaticIdentityValidationDisabled: boolean | null
    isLoading: boolean
    error: unknown
} => {
    const healthCareService = useCurrentHcs()
    const { data, isLoading, error } = useGetIdsHealthcareservicesHcsIdPreferences(healthCareService.id)

    return {
        isAutomaticIdentityValidationDisabled: data?.isInsAutomaticValidationDisabled ?? null,
        isLoading,
        error,
    }
}

export default useAutomaticIdentityValidation
